/**
 * Barre de filtres pour la liste des clients
 */
import React, { memo } from 'react';
import { CLIENT_TYPE_CONFIG } from './clientTypes';

const ClientsFilters = memo(({
  searchTerm,
  onSearchChange,
  filterType,
  onFilterTypeChange,
  filterStatus,
  onFilterStatusChange,
  filterGeocoding,
  onFilterGeocodingChange,
  typeStats,
  paginatedClients,
  selectedClients,
  onSelectAllVisible,
  totalCount
}) => {
  return (
    <div style={{
      background: 'white',
      padding: 'clamp(15px, 4vw, 20px)',
      borderRadius: '16px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
      marginBottom: '20px'
    }}>
      <div style={{
        display: 'flex',
        gap: 'clamp(10px, 3vw, 15px)',
        alignItems: 'center',
        flexWrap: 'wrap'
      }}>
        {/* Recherche */}
        <input
          type="text"
          placeholder="🔍 Nom, ville, CP, code, contact..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          style={{
            width: '280px',
            padding: '10px 14px',
            border: '2px solid #e1e5e9',
            borderRadius: '10px',
            fontSize: '14px',
            fontFamily: 'inherit',
            transition: 'border-color 0.2s ease',
            outline: 'none'
          }}
          onFocus={(e) => e.target.style.borderColor = '#fd7e14'}
          onBlur={(e) => e.target.style.borderColor = '#e1e5e9'}
        />

        {/* Filtres par type */}
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          {Object.entries(CLIENT_TYPE_CONFIG).map(([type, config]) => {
            const count = typeStats ? (type === 'non_qualifie' ? typeStats.non_qualifies : typeStats[type === 'agence_interim' ? 'agences_interim' : type + 's']) : 0;
            return (
              <button
                key={type}
                onClick={() => onFilterTypeChange(filterType === type ? '' : type)}
                style={{
                  padding: '8px 14px',
                  background: filterType === type ? config.color : config.bgColor,
                  color: filterType === type ? 'white' : config.color,
                  border: `2px solid ${config.color}`,
                  borderRadius: '20px',
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: '13px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  transition: 'all 0.2s',
                  whiteSpace: 'nowrap'
                }}
              >
                {config.label}
                <span style={{
                  background: filterType === type ? 'rgba(255,255,255,0.3)' : config.color,
                  color: 'white',
                  padding: '2px 8px',
                  borderRadius: '10px',
                  fontSize: '11px'
                }}>
                  {count || 0}
                </span>
              </button>
            );
          })}
        </div>

        {/* Filtres dropdown */}
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <select
            value={filterStatus}
            onChange={(e) => onFilterStatusChange(e.target.value)}
            style={{
              padding: '10px 12px',
              border: '2px solid #e1e5e9',
              borderRadius: '8px',
              fontSize: 'clamp(13px, 2.5vw, 14px)',
              minWidth: '120px'
            }}
          >
            <option value="">Tous les statuts</option>
            <option value="active">Actifs</option>
            <option value="inactive">Inactifs</option>
          </select>

          <select
            value={filterGeocoding}
            onChange={(e) => onFilterGeocodingChange(e.target.value)}
            style={{
              padding: '10px 12px',
              border: filterGeocoding === 'issues' || filterGeocoding === 'error' ? '2px solid #dc3545' :
                      filterGeocoding === 'warning' ? '2px solid #ffc107' :
                      filterGeocoding === 'ok' ? '2px solid #28a745' : '2px solid #e1e5e9',
              borderRadius: '8px',
              fontSize: 'clamp(13px, 2.5vw, 14px)',
              minWidth: '160px',
              background: filterGeocoding === 'issues' || filterGeocoding === 'error' ? '#fff5f5' :
                          filterGeocoding === 'warning' ? '#fffbeb' :
                          filterGeocoding === 'ok' ? '#f0fff4' : 'white'
            }}
          >
            <option value="">Validation adresse</option>
            <option value="issues">A corriger</option>
            <option value="error">Erreurs</option>
            <option value="warning">Avertissements</option>
            <option value="ok">Validees</option>
            <option value="pending">Non verifiees</option>
          </select>

          {/* Bouton select all */}
          <button
            onClick={onSelectAllVisible}
            style={{
              padding: '10px 14px',
              background: paginatedClients.every(c => selectedClients.includes(c.id)) ? '#6f42c1' : '#f8f9fa',
              color: paginatedClients.every(c => selectedClients.includes(c.id)) ? 'white' : '#495057',
              border: '2px solid #e1e5e9',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: '500'
            }}
          >
            {paginatedClients.every(c => selectedClients.includes(c.id)) ? 'Désélect.' : 'Sélect.'} page
          </button>
        </div>

        {/* Compteur résultats */}
        <span style={{ marginLeft: 'auto', color: '#666', fontSize: '14px', fontWeight: '500' }}>
          {totalCount} client(s)
        </span>
      </div>
    </div>
  );
});

ClientsFilters.displayName = 'ClientsFilters';

export default ClientsFilters;
